<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M4.857 0.439v31.134c0 0.237-0.363 0.428-0.81 0.428h-3.237c-0.448 0-0.81-0.192-0.81-0.428v-31.134c0-0.237 0.363-0.428 0.81-0.428h3.239c0.448 0 0.81 0.193 0.81 0.428zM19.729 0.439v31.134c0 0.237-0.363 0.428-0.81 0.428h-3.237c-0.448 0-0.81-0.192-0.81-0.428v-31.134c0-0.237 0.363-0.428 0.81-0.428h3.239c0.448 0 0.81 0.193 0.81 0.428z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
